/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Details/Gender",
  onChange
  
}) {
let gendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
})
let editRelationFromPersonRecordGenderValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.gender',
})
let editRelationFromPersonRecordGenderChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'from_person_record.gender',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 data="genders"
 from={gendersValueData}
 data="edit_relation.from_person_record.gender"
 value={editRelationFromPersonRecordGenderValueData}
 onChange={editRelationFromPersonRecordGenderChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Gender"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}